module.exports = shared_lib;